/** RFC 9457 problem details as the API returns them, with the correlation id and optional field errors. */
export interface ProblemDetails {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  correlationId?: string;
  errors?: Record<string, string[]>;
  [key: string]: unknown;
}

export function isProblemDetails(value: unknown): value is ProblemDetails {
  return typeof value === "object" && value !== null && ("title" in value || "errors" in value || "status" in value);
}

/** Flattens field errors to "field: message" lines for display; falls back to the title. */
export function problemMessages(problem: ProblemDetails | undefined, fallback: string): string[] {
  if (!problem) return [fallback];
  const fieldErrors = problem.errors ? Object.values(problem.errors).flat() : [];
  if (fieldErrors.length > 0) return fieldErrors;
  return [problem.detail ?? problem.title ?? fallback];
}
